import React, { useState } from "react";
import LoadingWithLable from "../../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import ListDataUpdateVisaDetails from "./ListDataUpdateVisaDetails";
import { useOutletContext, useParams } from "react-router-dom";
import CandidateExcelUpload from "../../CandidateExcelUpload";
import CandidateErrorPopUp from "../../CandidateErrorPopUp";
import CandidateErrorPopUpNew from "../../CandidateErrorPopUPNEW";

export default function CandidateListUpdateVisaDetails() {
  const { projectId } = useParams();

  const outletContext = useOutletContext();
  const { candidateListData, setCandidateListData, loading } = outletContext;

  console.log(candidateListData,"candidateListData......candidateListData")

  const [openCandidateUpload, setOpenCandidateUpload] = useState(false);
  const [showErrorPopUp, setShowErrorPopUp] = useState();

  return (
    <>
      {openCandidateUpload && (
        <CandidateExcelUpload
          showPromptElement={openCandidateUpload}
          setShowPromptElement={setOpenCandidateUpload}
          setShowErrorPopUp={setShowErrorPopUp}
          setCandidateListData={setCandidateListData}
          type="candidate_visa_details"
          title="Upload VISA Details"
          candidateData={candidateListData}
        />
      )}
      {showErrorPopUp && (
        <CandidateErrorPopUpNew
          showErrorPopUp={showErrorPopUp}
          onToggle={() => setShowErrorPopUp(false)}
        />
      )}
     
      {loading ? (
        <LoadingWithLable />
      ) : (
        <ListDataUpdateVisaDetails
          setOpenCandidateUpload={setOpenCandidateUpload}
          candidateData={candidateListData}
          projectId={projectId}
          setCandidateListData={setCandidateListData}
        />
      )}
    </>
  );
}
